module.exports = __webpack_public_path__ + "nc_static/media/options.b0f0dba1.svg";